import React, { useMemo, useState, useEffect } from 'react';
import { Redirect } from 'react-router';
import { Card, Dropdown, Empty, Menu, Space, Tooltip, Modal } from 'antd';
import { usePermify } from '@permify/react-role';
import moment from 'moment-timezone';
// v2 design system — activates scoped AntD overrides via .mjl-ds wrapper.
// See src/admin/platform/shared/designSystem/SPECIFICATION.md §9.
import './styles/index.scss';
import { useTimezone } from '../../../../core/hooks/useTimezone';
import { useDisplayRangeFilter } from './hooks/useDisplayRangeFilter';
import { isCustomerEditableStatus } from '../shared/editAccess';
import CampaignRangeSelector from './components/CampaignRangeSelector';
import CampaignOverviewChart from './components/CampaignOverviewChart';
import { fillDateSeries } from './utils';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import {
  Gauge,
  Monitor,
  ShoppingCart,
  Package,
  UserPlus,
  FileText,
  Clock,
  ChevronDown,
  Check,
  Download,
  Pencil,
  Link2,
  MessageSquare,
  Settings,
  Trash2,
} from 'lucide-react';
import {
  AdminModal,
  CampaignDetailBar,
  DropdownCSVButton,
  DropdownExcelButton,
  DynamicDropdownCSVButton,
  ProviderTabs,
  IntegrationsModal,
} from './components';

import CampaignOrderIssuesAlerts from './components/CampaignOrderIssuesAlerts';
import TaskThreadLoader from '../../../../core/components/campaigns/campaigndetails/tasks/TaskThreadLoader';
import { PageContentLayout, PageHeaderLayout } from '../../../shared/layout';
import {
  AttributionTab,
  OverviewTab,
  TransactionsTab,
  SignUpsTab,
  BasketItemsTab,
  TransactionsTabV2,
  BasketItemsTabV2,
  SignUpsV2Tab,
} from './tabs';
import Button from '../../../shared/globalStyling/Button';
import StatusTag, { getServedImpressions } from '../shared/StatusTag';
import { PageTitle, PageHeaderActions, Spinner } from '../../../shared/designSystem';
import { isEmpty } from 'lodash';
import AmplifyView from './amplify/AmplifyView';

import CampaignStatus from '../../CampaignOrderQueue/components/CampaignStatus';

// Global Styles
import { TabText } from '../../../shared/globalStyling/styledText';
import SummaryTab from './tabs/summary/SummaryTab';
import { orgLevelCustomization } from '../../../../core/permissions/orgLevelCustomization';
import { HasAccess } from '@permify/react-role';

import ResultPage from '../../../shared/ResultPage';
import PageViewTab from './tabs/pageView';
import SessionsTab from './tabs/sessions';
import SessionsTabV2 from './tabs/sessionsV2';
import { hasCampaignsFeature } from '../../../ux/Tasks/utils/task.utils';

const { confirm } = Modal;

const colStyle = {
  cssStyle: {
    backgroundColor: '#fff',
    padding: '10px',
  },
  histogram: {
    width: 'auto',
  },
  divider: { height: '6em' },
};

const CampaignDetails = ({
  updateUrlWithProvider,
  data,
  selectedProvider,
  attributionReportId,
  currentUser,
  campaignOrder,
  selectedTab,
  isSignupV2MigrationNeeded,
  history,
  location,
  chartData,
  setChartData,
  chartsLoading,
  modalOpen,
  toggleModal,
  orgConfig,
  dataConfig,
  updateCampaignOrder,
  providersVisible,
  providerIndex,
  setProviderIndex,
  isValidUrl,
  onDeleteCampaignOrder,
  getIsProcessor,
  getIsAdmin,
  getMessage,
  setGetListMessage,
  setGetCurrentConversationId,
  createMessageRemarks,
  message,
  getOrgName,
  loadingCreateMessage,
  setMessage,
  closeEditCampaign,
  signUpReportId,
  displayReportId,
  transactionReportId,
  transactionCSVReportId,
  basketItemsReportId,
  sessionsReportId,
  startObservationJob,
  isLoadingRefreshObservation,
  setIsLoadingRefreshObservation,
  selectedSegmentsDimension,
  setSegmentsDimension,
  reprocessCurrentCampaign,
  reprocessByCadence,
  scrapeDSPCampaigns,
  pauseLiquidMCampaign,
  startLiquidMCampaign,
  //useDynamicExport,
  exportButtonLoading,
  setExportButtonLoading,
  //setUseDynamicExport,
  exportButtonDisable,
  setExportButtonDisable,
  exportButtonMenuItems,
  setExportButtonMenuItems,
  updateCampaignOrderStatus,
  embeddableConfig,
  pageViewReportsKey,
  reprocessStatus,
  reprocessData,
  pauseOrStartLiquidMCampaign,
  loadingPauseOrStartLiquidMCampaign,
  issuesData,
  issuesLoading,
  pauseCampaign,
  loadingPauseCampaign,
  signupsV2Filters,
  setSignupsV2Filters,
}) => {
  //State controllers for campaigns range date selection Campaigns
  const [byCampaignRangeDate, setByCampaignRangeDate] = useState([]);
  const [dataCampaignRangeDate, setDataCampaignRangeDate] = useState([]);
  // Range preset key for the Display tab header ('Last 7 Days', 'Custom', ...).
  // Display-local — distinct from Summary's `rangeType` so tab switches don't
  // overwrite each other's active preset.
  const [campaignRangeType, setCampaignRangeType] = useState('Custom');

  // Mobile tab-dropdown open state. Desktop/tablet use the `.page-tabs` pill
  // track; below the sm breakpoint the pill track hides and consumers render
  // a `.page-tabs-dropdown` single-button trigger that opens a menu of tabs.
  // State lives here because the primitive is CSS-only — React toggle logic
  // is consumer-owned.
  const [tabsDropdownOpen, setTabsDropdownOpen] = useState(false);

  const [byWalkinRangeDate, setByWalkinRangeDate] = useState([]);
  const [dataWalkinRangeDate, setDataWalkinRangeDate] = useState([]);

  const [byWalkinRangeDateHead, setByWalkinRangeDateHead] = useState([]);
  const [dataWalkinRangeDateHead, setDataWalkinRangeDateHead] = useState([]);

  const [bySummaryRangeDate, setBySummaryRangeDate] = useState([]);
  const [dataSummaryRangeDate, setDataSummaryRangeDate] = useState([]);

  const [rangeType, setRangeType] = useState('Custom');

  const [bySignUpRangeDate, setSignUpRangeDate] = useState([]);
  const [dataSignUpRangeDate, setDataSignUpRangeDate] = useState([]);

  const [bySignUpsAttributionWindow, setbySignUpsAttributionWindow] = useState([]);
  const [dataSignUpsDate, setdataSignUpsDate] = useState([]);

  const [currentStatus, setCurrentStatus] = useState('0');

  // State controllers for transactions range date selection
  const [byTransactionsRangeDate, setByTransactionsRangeDate] = useState([]);
  const [dataTransactionsRangeDate, setDataTransactionsRangeDate] = useState([]);
  const [dataAttributionWindow, setDataAttributionWindow] = useState([]);
  const [dateTrue, setDateTrue] = useState(false);

  const [useDynamicExport, setUseDynamicExport] = useState(false);
  const [hasTransactionConfig, setHasTransactionConfig] = useState(false);
  const [integrationsModalVisible, setIntegrationsModalVisible] = useState(false);
  const [taskThreadModalVisible, setTaskThreadModalVisible] = useState(false);
  const orgCustomization = orgLevelCustomization(currentUser.role.org.dataConfig || {});
  const { currencyFormat } = orgCustomization;
  const { id, name, startDate, endDate, type } = data;
  // Set Document Title Dynamically
  let searchParams = new URLSearchParams(location.search);
  const selected = searchParams.get('tab');
  document.title = `${name} - ${
    selected ? (selected === 'overview' ? 'display' : selected) : 'summary'
  }`;

  useEffect(() => {
    const cart =
      campaignOrder && campaignOrder.transactionsConfig && campaignOrder.transactionsConfig.cart;

    if (cart) {
      setHasTransactionConfig(cart !== null && cart !== 'NOCART');
    }
  }, [campaignOrder]);

  useEffect(() => {
    const TabsWithDynamicExport = ['transactions', 'pageView', 'basketItemsV2', 'sessionsV2'];
    if (!TabsWithDynamicExport.includes(selected)) {
      setUseDynamicExport(false);
    } else {
      if (
        selected === 'transactions' &&
        ((data &&
          data.aggregateData &&
          data.aggregateData.overallData &&
          data.aggregateData.overallData.aggEvents &&
          data.aggregateData.overallData.aggEvents.transactionsTotalCount >= 5000) ||
          false)
      )
        setUseDynamicExport(true);
      else setUseDynamicExport(true);
    }
  }, [data, selected, selectedTab]);

  // Provider slicing + range filtering for the Display tab (#11679) live in a
  // shared hook so the regression suite drives the real wiring, not a copy.
  const { timezone: effectiveTimezone = 'UTC' } = useTimezone();
  const {
    displayChartData,
    campaignByDateNormalized,
    providersTab,
    isProviderSliceResolved,
  } = useDisplayRangeFilter(
    chartData,
    providerIndex,
    byCampaignRangeDate,
    setDataCampaignRangeDate
  );

  const defaultCampaignDateRange = useMemo(() => {
    if (!campaignByDateNormalized.length) return null;
    const stamps = campaignByDateNormalized
      .map((d) => d.xAxis)
      .filter(Boolean)
      .map((x) => moment.utc(x));
    if (!stamps.length) return null;
    return [moment.min(stamps), moment.max(stamps)];
  }, [campaignByDateNormalized]);

  // ---------------------------------------------------------------------------
  // Flight-bounded picker + zero-filled chart series.
  //
  // Problem: the picker clamped to the DELIVERY extent (byDate min/max), so a
  // flight starting June 1 whose first delivery bucket is June 2 made June 1
  // unselectable, and the chart's category X-axis omitted empty days entirely.
  //
  // Both pieces below are guarded on an available campaign-order flight window
  // (`data.startDate/endDate`). When absent — e.g. a single provider is selected
  // (an IO node with no order-level dates) — both fall back to today's behavior.
  //   1. flightDisabledDate — bounds the picker to the flight window instead of
  //      the delivery extent, so pre-delivery days become selectable. Forwarded
  //      through CampaignRangeSelector; it short-circuits DateRangeMenu's default
  //      clamp while leaving `defaultCampaignDateRange` (label + "All Time") intact.
  //   2. chartByDateFilled — a CHART-ONLY continuous series: zero-fills empty UTC
  //      days across the selected range (clamped to today, so a still-running
  //      flight paints no future zero tail). Kept SEPARATE from
  //      `dataCampaignRangeDate` so the KPI bar / previous-period delta / other
  //      tabs keep reading the unfilled array (sums, CTR and deltas stay exact).
  // Day-stepping uses moment.utc + the same picker→UTC-day bridge as anchor 4
  // above, preserving the locked four-anchor UTC contract (no start-edge clip).
  // ---------------------------------------------------------------------------
  // Flight window rendered in UTC — matching how the flight dates were entered
  // (UTC-midnight, e.g. `2026-06-01T00:00:00.000Z`) and the chart's UTC byDate
  // buckets. This keeps the intended June 1 start (reading these dates in a
  // west-of-UTC zone like California would shift the start back to May 31) and
  // ends at the real line-item end (July 31). The Flight Dates card is UTC-
  // anchored to match (see CampaignDetailBar). The picker→UTC-day bridge and the
  // zero-fill day-stepping below are already UTC, preserving the KPI contract.
  const flightBounds = useMemo(() => {
    if (!data || !data.startDate || !data.endDate) return null;
    return {
      start: moment.utc(data.startDate).format('YYYY-MM-DD'),
      end: moment.utc(data.endDate).format('YYYY-MM-DD'),
    };
  }, [data]);

  const flightDisabledDate = useMemo(() => {
    if (!flightBounds) return undefined; // no flight window → keep delivery-extent clamp
    const min = moment.utc(flightBounds.start, 'YYYY-MM-DD');
    const max = moment.utc(flightBounds.end, 'YYYY-MM-DD');
    return (current) => {
      if (!current) return false;
      const day = moment.utc(current.format('YYYY-MM-DD'), 'YYYY-MM-DD');
      return day.isBefore(min, 'day') || day.isAfter(max, 'day');
    };
  }, [flightBounds]);

  const chartByDateFilled = useMemo(() => {
    if (!flightBounds) return dataCampaignRangeDate;
    if (!byCampaignRangeDate || byCampaignRangeDate.length !== 2) return dataCampaignRangeDate;
    const startStr = moment
      .utc(moment(byCampaignRangeDate[0]).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      .format('YYYY-MM-DD');
    const rawEndStr = moment
      .utc(moment(byCampaignRangeDate[1]).format('YYYY-MM-DD'), 'YYYY-MM-DD')
      .format('YYYY-MM-DD');
    const todayStr = moment.utc().format('YYYY-MM-DD');
    const endStr = rawEndStr > todayStr ? todayStr : rawEndStr;
    return fillDateSeries(dataCampaignRangeDate, startStr, endStr, {
      xAxisKey: 'xAxis',
      zeroFields: ['impressions', 'clicks', 'ctr', 'cost', 'cpc', 'cpm', 'ecpm'],
    });
  }, [dataCampaignRangeDate, byCampaignRangeDate, flightBounds]);

  // Post-launch edit access is processor-only (see shared/editAccess.js).
  // Permify roles reflect org-preview swaps, so this is the effective permission.
  const { isAuthorized } = usePermify();
  const [isProcessor, setIsProcessor] = useState(false);
  useEffect(() => {
    const checkPermission = async () => {
      setIsProcessor(await isAuthorized(['isProcessor'], []));
    };
    checkPermission();
  }, [isAuthorized]);

  const checkStatus = data && data.status;
  const checkIsEditCampaign = data && data.isEditCampaign;
  const description = data && data.description;
  const getDescription = description ? description : '';

  if (isEmpty(data)) return <Redirect to="/campaigns" />;

  const {
    isTrafficker,
    hasInsights,
    isSelfService,
    isAdmin,
    exportData,
    providersVisible: isProvidersVisible,
    priceVisible,
    campaignSummary,
  } = orgConfig;

  const { amplify, sitesAppsTransactions, isTrafficker: userIsTrafficker } = currentUser.permission;

  const {
    transactionTarget,
    campaigns,
    attributionTargets,
    signUpCampaign,
    signUpConfig,
    pageViewConfig,
    sessionConfig,
    transactionsConfig,
  } = campaignOrder;
  const hasEcommerceAttribution = !!transactionsConfig;

  const idProvider =
    providerIndex === 'All'
      ? name
      : providersTab &&
        providersTab[providerIndex] &&
        providersTab[providerIndex][2] &&
        providersTab[providerIndex][2].id;
  const dataCampaigns = data && data.campaigns && data.campaigns;
  const selectedCampaignName = dataCampaigns.find((val) => val.id === idProvider);
  const getSelectedName = (selectedCampaignName && selectedCampaignName.name) || '';

  //const getIsRequestChange = data && data.isRequestChange;

  //Kludge check for multiple ios within providers
  let providers = [];

  campaigns.forEach((io) => {
    const { demandSidePlatform } = io;
    if (!providers.includes(demandSidePlatform)) {
      providers.push(demandSidePlatform);
    }
  });

  const getDefaultRoleTrafficker =
    currentUser &&
    currentUser.defaultRole &&
    currentUser.defaultRole.permission &&
    currentUser.defaultRole.permission.isTrafficker;

  const TabTopUI = () => {
    // Shared across both layouts — keeps props in sync between the wide
    // `.page-tabs-row__exports` pair and the narrow merged dropdown overlay.
    const showExports =
      selectedTab !== 'basketItems' && (isAdmin || exportData) && checkStatus !== 'DRAFT';

    const csvButton = showExports ? (
      <DropdownCSVButton
        tabKey={selectedTab}
        orgConfig={orgConfig}
        campaignName={name}
        campaignType={type}
        campaignId={id}
        chartsLoading={chartsLoading}
        chartData={chartData}
        attributionReportId={attributionReportId}
        campaigns={campaignOrder.campaigns}
        isAdmin={currentUser.isAdmin}
        hasInsights={hasInsights}
        byCampaignRangeDate={byCampaignRangeDate}
        bySummaryRangeDate={bySummaryRangeDate}
        dataSummaryRangeDate={dataSummaryRangeDate}
        byTransactionsRangeDate={byTransactionsRangeDate}
        dataAttributionWindow={dataAttributionWindow}
        bySignUpRangeDate={bySignUpRangeDate}
        byWalkinRangeDate={byWalkinRangeDate}
        rangeType={rangeType}
        amplify={amplify}
        sitesAppsTransactions={sitesAppsTransactions}
        signupsV2Filters={signupsV2Filters}
      />
    ) : null;

    const excelButton = showExports ? (
      <DropdownExcelButton
        tabKey={selectedTab}
        orgConfig={orgConfig}
        campaignName={name}
        campaignType={type}
        campaignId={id}
        chartsLoading={chartsLoading}
        chartData={chartData}
        attributionReportId={attributionReportId}
        campaigns={campaignOrder.campaigns}
        isAdmin={currentUser.isAdmin}
        hasInsights={hasInsights}
        byCampaignRangeDate={byCampaignRangeDate}
        bySummaryRangeDate={bySummaryRangeDate}
        dataSummaryRangeDate={dataSummaryRangeDate}
        byTransactionsRangeDate={byTransactionsRangeDate}
        dataAttributionWindow={dataAttributionWindow}
        bySignUpRangeDate={bySignUpRangeDate}
        byWalkinRangeDate={byWalkinRangeDate}
        rangeType={rangeType}
        amplify={amplify}
        signupsV2Filters={signupsV2Filters}
      />
    ) : null;

    return (

      <React.Fragment>
        {!useDynamicExport ? (
          <>
            {/*
              Desktop / tablet — two full buttons side by side.
              Below md, CSS collapses this wrapper out of the flow and the
              merged dropdown below takes over.
            */}
            <div className="page-tabs-row__exports">
              {csvButton}
              {excelButton}
            </div>

            {/*
              Narrow — single `Export ▼` dropdown. Overlay hosts both
              original CSV + Excel buttons stacked vertically; each keeps
              its own sub-dropdown so the export picklists are intact.
              Two-level interaction: Export → pick CSV or Excel → pick
              a specific export variant.
            */}
            {showExports && (
              <Dropdown
                trigger={['click']}
                placement="bottomRight"
                overlayClassName="mjl-ds page-tabs-row__exports-menu"
                overlay={
                  <div className="page-tabs-row__exports-menu-panel">
                    {csvButton}
                    {excelButton}
                  </div>
                }
              >
                <button
                  type="button"
                  className="page-tabs-row__exports-trigger"
                  aria-label="Export"
                >
                  <Download
                    size={16}
                    strokeWidth={2}
                    className="page-tabs-row__exports-trigger-icon"
                  />
                  <span className="page-tabs-row__exports-trigger-label">Export</span>
                  <ChevronDown
                    size={14}
                    strokeWidth={2}
                    className="page-tabs-row__exports-trigger-chevron"
                  />
                </button>
              </Dropdown>
            )}
          </>
        ) : (
          <>
            {(isAdmin || exportData) && checkStatus !== 'DRAFT' ? (
              <DynamicDropdownCSVButton
                menuItems={exportButtonMenuItems}
                disabled={exportButtonDisable}
                loading={exportButtonLoading}
              />
            ) : null}
          </>
        )}
      </React.Fragment>
    );
  };
  return (
    <div className="modern-ui-scope mjl-ds">
      <React.Fragment>
      <PageHeaderLayout
        title={
          <PageTitle
            title={providerIndex === 'All' ? name : getSelectedName}
            description={getDescription}
            status={
              <HasAccess permissions={['default', 'defaultSSO']}>
                <StatusTag
                  startDate={startDate ? startDate : new Date().toString()}
                  endDate={endDate ? endDate : new Date().toString()}
                  statusCampaign={data.status && data.status}
                  attributionWindow={
                    data && data.attributionWindow ? data.attributionWindow : 'N/A'
                  }
                  impressions={getServedImpressions(data)}
                />
              </HasAccess>
            }
          />
        }
        //Right content currently has 2 modes - isTrafficker and isSelfService - for isTrafficker, edit campaign can in turn boost a campaigns budget so edit will only be diplayed
        //Self service customers that do not also have the isTrafficker role will see boost - to update a campaigns budget
        rightContent={(() => {
          // Permission predicates — verbatim from develop, preserved exactly
          // through every facelift pass. Each maps to a `PageHeaderActions`
          // slot (primary / secondary / destructive / iconActions / children).
          // Edit access: building/requesting phase keeps the original rule;
          // approved/in-flight orders are processor-only (shared/editAccess.js).
          const canEdit = isCustomerEditableStatus(checkStatus)
            ? isSelfService ||
              userIsTrafficker ||
              checkStatus === 'DRAFT' ||
              (currentUser.isPreviewOrg === true && getDefaultRoleTrafficker === true)
            : isProcessor;
          const canShowIntegrations =
            canEdit &&
            userIsTrafficker &&
            campaignOrder.attachments &&
            campaignOrder.attachments.length > 0;
          const canShowTaskThread =
            currentUser.features?.includes('TASK_MANAGEMENT') &&
            hasCampaignsFeature(currentUser);
          const canDiscard = checkStatus === 'DRAFT';
          const canAmplify =
            isSelfService &&
            !isTrafficker &&
            checkStatus !== 'DRAFT' &&
            checkStatus !== 'PENDING';
          const canAdmin = isTrafficker && userIsTrafficker;

          const secondary = [];
          if (canShowIntegrations) {
            secondary.push({
              key: 'integrations',
              label: 'Integrations',
              icon: <Link2 size={16} strokeWidth={2} />,
              onClick: () => setIntegrationsModalVisible(true),
            });
          }
          if (canShowTaskThread) {
            secondary.push({
              key: 'task-thread',
              label: 'Task Thread',
              icon: <MessageSquare size={16} strokeWidth={2} />,
              onClick: () => setTaskThreadModalVisible(true),
            });
          }

          return (
            <HasAccess permissions={['default', 'defaultSSO']}>
              <PageHeaderActions
                primary={
                  canEdit
                    ? {
                        label: 'Edit Campaign',
                        icon: <Pencil size={16} strokeWidth={2} />,
                        onClick: () => history.push(`/campaigns/requester/edit/${id}`),
                      }
                    : undefined
                }
                secondary={secondary}
                destructive={
                  canDiscard
                    ? {
                        label: 'Discard Draft',
                        icon: <Trash2 size={16} strokeWidth={2} />,
                        tooltip: 'Discard Draft to Delete the Draft Campaign',
                        onClick: () => {
                          confirm({
                            title: 'Would you like to delete this draft campaign?',
                            icon: <ExclamationCircleOutlined />,
                            onOk() {
                              onDeleteCampaignOrder();
                            },
                          });
                        },
                      }
                    : undefined
                }
                iconActions={
                  canAdmin
                    ? [
                        {
                          key: 'admin',
                          label: 'Admin',
                          icon: <Settings size={16} strokeWidth={2} />,
                          tooltip: 'Admin',
                          onClick: () => toggleModal(1),
                        },
                      ]
                    : []
                }
                collapseAt="xl"
              >
                {canAmplify && (
                  <AmplifyView
                    campaignOrder={campaignOrder}
                    updateCampaignOrder={updateCampaignOrder}
                  />
                )}
              </PageHeaderActions>
            </HasAccess>
          );
        })()}
      />
      <PageContentLayout>
        {checkStatus !== 'PENDING' && checkStatus !== 'APPROVED' && (
          <div
            id="printable-page"
            style={{
              fontVariant: 'normal',
            }}
          >
            <HasAccess permissions={['default', 'defaultSSO', 'displaySSO']}>
              {userIsTrafficker ? (
                <CampaignOrderIssuesAlerts
                  issues={issuesData?.campaignOrderIssues || []}
                  loading={issuesLoading}
                />
              ) : null}
              {(() => {
                // =====================================================
                // Page-level tab navigation — native `.page-tabs` pattern
                // (promoted from tailwind-preview.html §20) replaces the
                // AntD <Tabs>/<TabPane> chrome. Declarative `tabDefs`
                // array captures the old conditional TabPane rendering
                // (campaignSummary, transactionTarget, signUpCampaign,
                // pageViewConfig, sessionConfig) as data; the active
                // tab's `render()` fires below. URL-param `?tab=` state
                // preserved.
                //
                // Each V1/V2 switch (Transactions, BasketItems, SignUps,
                // Sessions) is encoded in its entry's `key` + `render`
                // so the tab key matches whichever path is actually shown.
                // =====================================================
                const handleTabChange = (key) => {
                  const searchParams = new URLSearchParams(location.search);
                  if (searchParams.get('tab')) searchParams.delete('tab');
                  searchParams.append('tab', key);
                  history.push(`${location.pathname}?${searchParams.toString()}`);
                };

                const tabDefs = [];

                if (campaignSummary) {
                  tabDefs.push({
                    key: 'summary',
                    label: 'Summary',
                    icon: <Gauge size={14} strokeWidth={2} />,
                    render: () =>
                      isValidUrl === true ? (
                        <SummaryTab
                          orgConfig={orgConfig}
                          exportData={exportData}
                          campaignOrder={campaignOrder}
                          providerIndex={providerIndex}
                          campaignType={type}
                          checkStatus={checkStatus}
                          currentUser={currentUser}
                          chartsLoading={chartsLoading}
                          campaignId={id}
                          campaignName={name}
                          providersTab={providersTab}
                          chartData={chartData}
                          attributionReportId={attributionReportId}
                          type={type}
                          isAdmin={currentUser.isAdmin}
                          showTransactions={transactionTarget}
                          signUpCampaign={signUpCampaign}
                          showAttribution={attributionTargets && !isEmpty(attributionTargets)}
                          hasEcommerceAttribution={hasEcommerceAttribution}
                          selectedCampaign={data}
                          isTrafficker={isTrafficker}
                          hasInsights={hasInsights}
                          bySummaryRangeDate={bySummaryRangeDate}
                          setBySummaryRangeDate={setBySummaryRangeDate}
                          dataSummaryRangeDate={dataSummaryRangeDate}
                          setDataSummaryRangeDate={setDataSummaryRangeDate}
                          setRangeType={setRangeType}
                          rangeType={rangeType}
                          priceVisible={priceVisible}
                          showSessions={sessionConfig && sessionConfig.isSession}
                        />
                      ) : (
                        <Card>
                          <Empty
                            description="Please refresh your browser to receive the latest updates."
                            style={{ marginTop: 16 }}
                          />
                        </Card>
                      ),
                  });
                }

                tabDefs.push({
                  key: 'overview',
                  label: 'Display',
                  icon: <Monitor size={14} strokeWidth={2} />,
                  render: () => (
                    <>
                      {data.type !== 'OOH' &&
                        providersTab &&
                        providersTab.length > 1 &&
                        isProvidersVisible && (
                          <ProviderTabs
                            updateUrlWithProvider={updateUrlWithProvider}
                            selectedProvider={selectedProvider}
                            providers={providers}
                            providersTab={providersTab}
                            providerIndex={providerIndex}
                            setProviderIndex={setProviderIndex}
                            providersVisible={providersVisible}
                            data={data}
                          />
                        )}
                      {/*
                         Performance section wrapped in `<Spinner spinning>`
                         so the whole card (header with range selector +
                         KPI bar + chart) gets the same blur-overlay
                         loading visual as the Transactions V2 tab —
                         matches the user's stated "blurs everything on
                         the performance card" reference. CampaignOverview
                         Chart still receives `loading` so its internal
                         Empty-state fallback reads as skeleton underneath
                         the overlay if the section is cheated by a
                         render-before-useEffect-commits window.
                      */}
                      <Spinner spinning={chartsLoading}>
                        <section className="campaign-overview__performance">
                          <header className="campaign-overview__performance-head">
                            <div className="campaign-overview__performance-eyebrow mono-eyebrow">
                              Performance
                            </div>
                            <CampaignRangeSelector
                              rangeType={campaignRangeType}
                              byCampaignRangeDate={byCampaignRangeDate}
                              setRangeType={setCampaignRangeType}
                              setByCampaignRangeDate={setByCampaignRangeDate}
                              timezone={effectiveTimezone}
                              defaultDateRange={defaultCampaignDateRange}
                              disabledDate={flightDisabledDate}
                            />
                          </header>

                          <CampaignDetailBar
                            name={name}
                            colStyle={colStyle}
                            selectedCampaign={data}
                            selectedProvider={selectedProvider}
                            byCampaignRangeDate={byCampaignRangeDate}
                            dataCampaignRangeDate={dataCampaignRangeDate}
                            providersTab={providersTab}
                            providerIndex={providerIndex}
                          />

                          {/* displayChartData: byDay/Device read off this prop (#11679) */}
                          <CampaignOverviewChart
                            chartData={displayChartData}
                            dataCampaignRangeDate={chartByDateFilled}
                            chartsBuilt={displayChartData && displayChartData.chartsBuilt}
                            loading={chartsLoading}
                            dataSettled={!chartsLoading && isProviderSliceResolved}
                          />
                        </section>
                      </Spinner>

                      {isValidUrl === true && (
                        <OverviewTab
                          providerIndex={providerIndex}
                          providersTab={providersTab}
                          chartData={chartData}
                          setChartData={setChartData}
                          campaignOrder={campaignOrder}
                          chartsLoading={chartsLoading}
                          displayReportId={displayReportId}
                          type={type}
                          selectedCampaign={data}
                          isTrafficker={isTrafficker}
                          hasInsights={hasInsights}
                          byCampaignRangeDate={byCampaignRangeDate}
                          setByCampaignRangeDate={setByCampaignRangeDate}
                          dataCampaignRangeDate={dataCampaignRangeDate}
                          setDataCampaignRangeDate={setDataCampaignRangeDate}
                          selectedSegmentsDimension={selectedSegmentsDimension}
                          setSegmentsDimension={setSegmentsDimension}
                        />
                      )}
                    </>
                  ),
                });

                if (transactionTarget) {
                  const isV1Transactions =
                    transactionReportId && !campaignOrder?.reportDetails?.transaction?.id;

                  tabDefs.push({
                    key: 'transactions',
                    label: 'Transactions',
                    icon: <ShoppingCart size={14} strokeWidth={2} />,
                    render: () =>
                      isV1Transactions ? (
                        <TransactionsTab
                          dataConfig={dataConfig}
                          colStyle={colStyle}
                          selectedCampaign={data}
                          campaignOrder={campaignOrder}
                          chartsLoading={chartsLoading}
                          chartData={chartData}
                          setChartData={setChartData}
                          byTransactionsRangeDate={byTransactionsRangeDate}
                          dataAttributionWindow={dataAttributionWindow}
                          setDataAttributionWindow={setDataAttributionWindow}
                          setByTransactionsRangeDate={setByTransactionsRangeDate}
                          dataTransactionsRangeDate={dataTransactionsRangeDate}
                          setDataTransactionsRangeDate={setDataTransactionsRangeDate}
                          byCampaignRangeDate={byCampaignRangeDate}
                          setByCampaignRangeDate={setByCampaignRangeDate}
                          dataCampaignRangeDate={dataCampaignRangeDate}
                          setDataCampaignRangeDate={setDataCampaignRangeDate}
                          transactionTarget={transactionTarget}
                          transactionReportId={transactionReportId}
                          transactionCSVReportId={transactionCSVReportId}
                          dateTrue={dateTrue}
                          setDateTrue={setDateTrue}
                          priceVisible={priceVisible}
                          useDynamicExport={useDynamicExport}
                          setUseDynamicExport={setUseDynamicExport}
                          setExportButtonLoading={setExportButtonLoading}
                          setExportButtonDisable={setExportButtonDisable}
                          setExportButtonMenuItems={setExportButtonMenuItems}
                          location={location}
                          currentUser={currentUser}
                          currencyFormat={currencyFormat}
                        />
                      ) : (
                        <TransactionsTabV2
                          currentUser={currentUser}
                          campaignOrder={campaignOrder}
                          location={location}
                          setExportButtonLoading={setExportButtonLoading}
                          setExportButtonDisable={setExportButtonDisable}
                          setExportButtonMenuItems={setExportButtonMenuItems}
                          setUseDynamicExport={setUseDynamicExport}
                        />
                      ),
                  });

                  if (
                    campaignOrder.transactionsConfig &&
                    campaignOrder.transactionsConfig.tracksBasketItems
                  ) {
                    const isV1Basket =
                      basketItemsReportId && !campaignOrder.reportDetails?.transaction?.id;

                    tabDefs.push({
                      key: isV1Basket ? 'basketItems' : 'basketItemsV2',
                      label: 'Basket Items',
                      icon: <Package size={14} strokeWidth={2} />,
                      render: () =>
                        isV1Basket ? (
                          <BasketItemsTab
                            colStyle={colStyle}
                            selectedCampaign={data}
                            campaignOrder={campaignOrder}
                            chartsLoading={chartsLoading}
                            chartData={chartData}
                            setChartData={setChartData}
                            byTransactionsRangeDate={byTransactionsRangeDate}
                            setByTransactionsRangeDate={setByTransactionsRangeDate}
                            dataTransactionsRangeDate={dataTransactionsRangeDate}
                            setDataTransactionsRangeDate={setDataTransactionsRangeDate}
                            byCampaignRangeDate={byCampaignRangeDate}
                            setByCampaignRangeDate={setByCampaignRangeDate}
                            dataCampaignRangeDate={dataCampaignRangeDate}
                            setDataCampaignRangeDate={setDataCampaignRangeDate}
                            transactionTarget={transactionTarget}
                            basketItemsReportId={basketItemsReportId}
                            location={location}
                          />
                        ) : (
                          <BasketItemsTabV2
                            currentUser={currentUser}
                            campaignOrder={campaignOrder}
                            basketItemsReportId={basketItemsReportId}
                            location={location}
                            setExportButtonLoading={setExportButtonLoading}
                            setExportButtonDisable={setExportButtonDisable}
                            setExportButtonMenuItems={setExportButtonMenuItems}
                            setUseDynamicExport={setUseDynamicExport}
                          />
                        ),
                    });
                  }
                }

                if (signUpCampaign && signUpConfig) {
                  tabDefs.push({
                    key: !isSignupV2MigrationNeeded ? 'signupsV2' : 'signups',
                    label: 'Sign Ups',
                    icon: <UserPlus size={14} strokeWidth={2} />,
                    render: () =>
                      !isSignupV2MigrationNeeded ? (
                        <SignUpsV2Tab
                          campaignOrder={campaignOrder}
                          location={location}
                          setSignupsV2Filters={setSignupsV2Filters}
                        />
                      ) : (
                        <SignUpsTab
                          dataConfig={dataConfig}
                          colStyle={colStyle}
                          chartData={chartData}
                          setChartData={setChartData}
                          selectedCampaign={data}
                          signUpReportId={signUpReportId}
                          campaignOrder={campaignOrder}
                          bySignUpRangeDate={bySignUpRangeDate}
                          setSignUpRangeDate={setSignUpRangeDate}
                          dataSignUpRangeDate={dataSignUpRangeDate}
                          setDataSignUpRangeDate={setDataSignUpRangeDate}
                          setbySignUpsAttributionWindow={setbySignUpsAttributionWindow}
                          setdataSignUpsDate={setdataSignUpsDate}
                          bySignUpsAttributionWindow={bySignUpsAttributionWindow}
                          dataSignUpsDate={dataSignUpsDate}
                          location={location}
                        />
                      ),
                  });
                }

                if (pageViewConfig && pageViewConfig.appId) {
                  tabDefs.push({
                    key: 'pageView',
                    label: 'Page Views',
                    icon: <FileText size={14} strokeWidth={2} />,
                    render: () => (
                      <PageViewTab
                        reportKey={pageViewReportsKey}
                        campaignOrder={campaignOrder}
                        setExportButtonLoading={setExportButtonLoading}
                        setExportButtonDisable={setExportButtonDisable}
                        setExportButtonMenuItems={setExportButtonMenuItems}
                      />
                    ),
                  });
                }

                if (sessionConfig && sessionConfig.isSession) {
                  const isV1Sessions =
                    sessionsReportId && !campaignOrder.reportDetails?.sessions;

                  tabDefs.push({
                    key: isV1Sessions ? 'sessions' : 'sessionsV2',
                    label: 'Sessions',
                    icon: <Clock size={14} strokeWidth={2} />,
                    render: () =>
                      isV1Sessions ? (
                        <SessionsTab
                          reportKey={sessionsReportId}
                          campaignOrder={campaignOrder}
                          setExportButtonLoading={setExportButtonLoading}
                          setExportButtonDisable={setExportButtonDisable}
                          setExportButtonMenuItems={setExportButtonMenuItems}
                          setUseDynamicExport={setUseDynamicExport}
                        />
                      ) : (
                        <SessionsTabV2
                          campaignOrder={campaignOrder}
                          setExportButtonLoading={setExportButtonLoading}
                          setExportButtonDisable={setExportButtonDisable}
                          setExportButtonMenuItems={setExportButtonMenuItems}
                          setUseDynamicExport={setUseDynamicExport}
                        />
                      ),
                  });
                }

                const activeTab =
                  tabDefs.find((t) => t.key === selectedTab) || tabDefs[0];

                // Close the mobile dropdown when a tab is picked.
                const pickTab = (key) => {
                  handleTabChange(key);
                  setTabsDropdownOpen(false);
                };

                return (
                  <>
                    <div className="page-tabs-row">
                      {/* Desktop / tablet — pill track. Hidden below sm. */}
                      <nav
                        className="page-tabs"
                        role="tablist"
                        aria-label="Campaign Details sections"
                      >
                        {tabDefs.map((t) => (
                          <button
                            key={t.key}
                            role="tab"
                            type="button"
                            aria-selected={selectedTab === t.key}
                            className={
                              'page-tabs__btn' +
                              (selectedTab === t.key ? ' page-tabs__btn--active' : '')
                            }
                            onClick={() => handleTabChange(t.key)}
                          >
                            {t.icon && (
                              <span className="page-tabs__icon" aria-hidden="true">
                                {t.icon}
                              </span>
                            )}
                            <span className="page-tabs__label">{t.label}</span>
                          </button>
                        ))}
                      </nav>

                      {/*
                        Mobile — dropdown trigger + menu. Hidden above sm.
                        Trigger shows the active tab; menu lists all tabs
                        with the active one tinted + a check glyph. Backdrop
                        closes on tap-outside; Escape also closes.
                      */}
                      <div className="page-tabs-dropdown">
                        <button
                          type="button"
                          className="page-tabs-dropdown__trigger"
                          aria-expanded={tabsDropdownOpen}
                          aria-haspopup="listbox"
                          aria-label="Campaign Details sections"
                          onClick={() => setTabsDropdownOpen((o) => !o)}
                        >
                          {activeTab && activeTab.icon && (
                            <span className="page-tabs-dropdown__icon" aria-hidden="true">
                              {activeTab.icon}
                            </span>
                          )}
                          <span className="page-tabs-dropdown__label">
                            {activeTab ? activeTab.label : 'Sections'}
                          </span>
                          <ChevronDown
                            size={16}
                            strokeWidth={2}
                            className={
                              'page-tabs-dropdown__chevron' +
                              (tabsDropdownOpen
                                ? ' page-tabs-dropdown__chevron--open'
                                : '')
                            }
                            aria-hidden="true"
                          />
                        </button>
                        {tabsDropdownOpen && (
                          <>
                            <div
                              className="page-tabs-dropdown__backdrop"
                              onClick={() => setTabsDropdownOpen(false)}
                            />
                            <ul
                              className="page-tabs-dropdown__menu"
                              role="listbox"
                              onKeyDown={(e) => {
                                if (e.key === 'Escape') {
                                  setTabsDropdownOpen(false);
                                }
                              }}
                            >
                              {tabDefs.map((t) => {
                                const isActive = selectedTab === t.key;
                                return (
                                  <li
                                    key={t.key}
                                    role="option"
                                    aria-selected={isActive}
                                    tabIndex={0}
                                    className={
                                      'page-tabs-dropdown__item' +
                                      (isActive
                                        ? ' page-tabs-dropdown__item--active'
                                        : '')
                                    }
                                    onClick={() => pickTab(t.key)}
                                    onKeyDown={(e) => {
                                      if (e.key === 'Enter' || e.key === ' ') {
                                        e.preventDefault();
                                        pickTab(t.key);
                                      }
                                    }}
                                  >
                                    {t.icon && (
                                      <span
                                        className="page-tabs-dropdown__item-icon"
                                        aria-hidden="true"
                                      >
                                        {t.icon}
                                      </span>
                                    )}
                                    <span className="page-tabs-dropdown__item-label">
                                      {t.label}
                                    </span>
                                    {isActive && (
                                      <Check
                                        size={14}
                                        strokeWidth={2.5}
                                        className="page-tabs-dropdown__item-check"
                                        aria-hidden="true"
                                      />
                                    )}
                                  </li>
                                );
                              })}
                            </ul>
                          </>
                        )}
                      </div>

                      <div className="page-tabs-row__extra">{TabTopUI()}</div>
                    </div>
                    <div role="tabpanel" className="page-tabs__content">
                      {activeTab ? activeTab.render() : null}
                    </div>
                  </>
                );
              })()}
            </HasAccess>
            <HasAccess permissions={['widgetSSO']}>
              {hasTransactionConfig === true ? (
                <TransactionsTab
                  dataConfig={dataConfig}
                  colStyle={colStyle}
                  selectedCampaign={data}
                  campaignOrder={campaignOrder}
                  chartsLoading={chartsLoading}
                  chartData={chartData}
                  setChartData={setChartData}
                  byTransactionsRangeDate={byTransactionsRangeDate}
                  dataAttributionWindow={dataAttributionWindow}
                  setDataAttributionWindow={setDataAttributionWindow}
                  setByTransactionsRangeDate={setByTransactionsRangeDate}
                  dataTransactionsRangeDate={dataTransactionsRangeDate}
                  setDataTransactionsRangeDate={setDataTransactionsRangeDate}
                  byCampaignRangeDate={byCampaignRangeDate}
                  setByCampaignRangeDate={setByCampaignRangeDate}
                  dataCampaignRangeDate={dataCampaignRangeDate}
                  setDataCampaignRangeDate={setDataCampaignRangeDate}
                  transactionTarget={transactionTarget}
                  transactionReportId={transactionReportId}
                  transactionCSVReportId={transactionCSVReportId}
                  dateTrue={dateTrue}
                  setDateTrue={setDateTrue}
                  priceVisible={priceVisible}
                  useDynamicExport={useDynamicExport}
                  setUseDynamicExport={setUseDynamicExport}
                  setExportButtonLoading={setExportButtonLoading}
                  setExportButtonDisable={setExportButtonDisable}
                  setExportButtonMenuItems={setExportButtonMenuItems}
                  location={location}
                  currentUser={currentUser}
                  currencyFormat={currencyFormat}
                  embeddableConfig={embeddableConfig}
                />
              ) : (
                ResultPage({
                  status: 'warning',
                  title: 'No Widgets Available',
                })
              )}
            </HasAccess>

            <HasAccess permissions={['default', 'defaultSSO']}>
              <TaskThreadLoader
                campaignId={id}
                currentUser={currentUser}
                history={history}
                modalVisible={taskThreadModalVisible}
                onModalClose={() => setTaskThreadModalVisible(false)}
              />
            </HasAccess>
          </div>
        )}
        {(checkStatus === 'PENDING' || checkStatus === 'APPROVED') && (
          <CampaignStatus
            isCampaignDetails={true}
            getIsProcessor={getIsProcessor}
            getIsAdmin={getIsAdmin}
            //changeValue={changeValue}
            selectedCampaignOrder={data}
            createMessageRemarks={createMessageRemarks}
            message={message}
            getMessage={getMessage}
            getOrgName={getOrgName}
            loadingCreateMessage={loadingCreateMessage}
            setGetListMessage={setGetListMessage}
            setGetCurrentConversationId={setGetCurrentConversationId}
            setMessage={setMessage}
            checkStatus={checkStatus}
            checkIsEditCampaign={checkIsEditCampaign}
            closeEditCampaign={closeEditCampaign}
            currentStatus={currentStatus}
            setCurrentStatus={setCurrentStatus}
          />
        )}
      </PageContentLayout>
      {modalOpen > 0 && (
        <AdminModal
          isLoadingRefreshObservation={isLoadingRefreshObservation}
          setIsLoadingRefreshObservation={setIsLoadingRefreshObservation}
          startObservationJob={startObservationJob}
          modalOpen={modalOpen}
          toggleModal={toggleModal}
          campaignOrder={campaignOrder}
          reprocessCurrentCampaign={reprocessCurrentCampaign}
          reprocessByCadence={reprocessByCadence}
          onDeleteCampaignOrder={onDeleteCampaignOrder}
          campaignId={id}
          scrapeDSPCampaigns={scrapeDSPCampaigns}
          campaign={data}
          pauseLiquidMCampaign={pauseLiquidMCampaign}
          startLiquidMCampaign={startLiquidMCampaign}
          updateCampaignOrderStatus={updateCampaignOrderStatus}
          reprocessStatus={reprocessStatus}
          reprocessData={reprocessData}
          pauseOrStartLiquidMCampaign={pauseOrStartLiquidMCampaign}
          loadingPauseOrStartLiquidMCampaign={loadingPauseOrStartLiquidMCampaign}
          pauseCampaign={pauseCampaign}
          loadingPauseCampaign={loadingPauseCampaign}
        />
      )}
      <IntegrationsModal
        visible={integrationsModalVisible}
        onClose={() => setIntegrationsModalVisible(false)}
        attachments={campaignOrder.attachments}
      />
    </React.Fragment>
    </div>
  );
};

export default CampaignDetails;
